import React from 'react';

import { I18nProvider } from '@lingui/react';
import { i18n } from '@lingui/core';
import { observer } from 'mobx-react-lite';

import Main from './Main';
import { useOnetrustGroupsUpdate } from 'helpers/onetrustGroups';

const App = observer(function App() {
    useOnetrustGroupsUpdate();

    return (
        <I18nProvider i18n={i18n}>
            <Main />
        </I18nProvider>
    );
});

export default App;
